import { render } from "./Cut30AlumBadge.vue?vue&type=template&id=53c5a7f3"
import script from "./Cut30AlumBadge.vue?vue&type=script&lang=js"
export * from "./Cut30AlumBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__